export const unprotectedRoutes = [
    '/login',
    '/signup',
    '/verify-magic-link',
    '/verify-invite-link',
    '/shopify/auth',
    '/self/auth',
    '/styleguide',
    '/admin-editor-preview',
    '/admin-product-preview',
]
